import axios from "axios";

import { useConfigStore } from "../stores/config";
import { useUserStore } from "../stores/user";
import { sendNotification } from "./notificationService";


let host = (window.location.host).replace(':8080', '');
host = (host).replace(':8081', '');
let domain = host.split('.')[0]
let url = '';
switch (domain) {

  case 'localhost':
  case '127':
  case 'marbel-pop':
  case 'mb-front-9wwke':
  case 'marbel-prod':
  case 'marbel-dev':
    url = "https://marbel-backend.iteracrea.com/api/";
    break;


  default:
    url = 'https://mb-back-dev-new-ol4ed.ondigitalocean.app/api/';
    break;
}
const serviceInstance = axios.create({
  baseURL: url,
  headers: {
    Accept: "application/json"
  },
  timeout: 1000000,
});
var _axios_config = {
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    Authorization: "",
  },
};
const validation = (data) => {
  let text = "";
  for (var [key, value] of Object.entries(data.errors)) {
    text +=
      '<div class="w-full flex flex-wrap text-center justify-center content-center"><span>' +
      value +
      "</span> </div><br>"; // "a 5", "b 7", "c 9"
  }
  return text;
  //emitter.emit("alerta_show",text);
};
export default {
  data() {
    const config = useConfigStore();

    return { config, user };
  },

  formatrespuesta: (method, data, url, auth, file) => {
    let result = null;
    let config = JSON.parse(JSON.stringify(_axios_config)); // Crear una copia profunda
    if (auth) {
      const user = useUserStore();
      let tok = user.token;
      //let us=user.getAll();
      config.headers.Authorization = "Bearer " + tok;
    }
    switch (method) {
      case "post":
        if (file) {
          config.headers["Content-Type"] = "multipart/form-data";
        } else {
          config.headers["Content-Type"] = "application/json";
        }

        result = serviceInstance
          .post(url, data, config)
          .then((response) => {
            return response.data;
          })
          .catch(function (error) {
            console.log('Error en POST:', error);
            if (error.response) {
              console.log('Error response data:', error.response.data);
              console.log('Error response status:', error.response.status);

              switch (error.response.status) {
                case 422:
                  if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                    sendNotification(`Error 422 en POST ${url}: ${JSON.stringify(error.response.data)}`);
                  }
                  return { error: validation(error.response.data) };

                  break;

                case 500:
                  if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                    sendNotification(`Error 500 en POST ${url}: ${error.response.data.message || 'Error interno'}`);
                  }
                  return { error: error.response.data.message };
                  break;
              }
            } else {
              if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                sendNotification(`Error de red o desconocido en POST ${url}: ${error.message || error}`);
              }
              return { error: error };
            }
          });

        return result;

        break;
      case "get":
        result = serviceInstance
          .get(url, config)
          .then((response) => {
            return response.data;
          })
          .catch(function (error) {
            if (error.response) {


              switch (error.response.status) {
                case 422:
                  if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                    sendNotification(`Error 422 en GET ${url}: ${JSON.stringify(error.response.data)}`);
                  }
                  return { error: validation(error.response.data) };

                  break;

                case 500:
                  let errMsg = 'Error interno';
                  if (error.response.hasOwnProperty("data")) {
                    if (error.response.hasOwnProperty("message")) {
                      errMsg = error.response.data;
                    } else {
                      errMsg = error.response.data.message;
                    }
                  } else {
                    errMsg = error.response.data.message;
                  }
                  if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                    sendNotification(`Error 500 en GET ${url}: ${errMsg}`);
                  }
                  return { error: errMsg };
                  break;
              }
            } else {
              if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                sendNotification(`Error de red o desconocido en GET ${url}: ${error.message || error}`);
              }
              return { error: error };
            }
          });

        return result;

        break;
      case "put":
        if (file) {
          config.headers["Content-Type"] = "multipart/form-data";
        } else {
          config.headers["Content-Type"] = "application/json";
        }
        result = serviceInstance
          .put(url, data, config)
          .then((response) => {
            return response.data;
          })
          .catch(function (error) {
            if (error.response) {


              switch (error.response.status) {
                case 422:
                  if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                    sendNotification(`Error 422 en PUT ${url}: ${JSON.stringify(error.response.data)}`);
                  }
                  return { error: validation(error.response.data) };

                  break;

                case 500:
                  let errMsg = 'Error interno';
                  if (error.response.hasOwnProperty("data")) {
                    if (error.response.hasOwnProperty("message")) {
                      errMsg = error.response.data;
                    } else {
                      errMsg = error.response.data.message;
                    }
                  } else {
                    errMsg = error.response.data.message;
                  }
                  if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                    sendNotification(`Error 500 en PUT ${url}: ${errMsg}`);
                  }
                  return { error: errMsg };

                  break;
              }
            } else {
              if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                sendNotification(`Error de red o desconocido en PUT ${url}: ${error.message || error}`);
              }
              return { error: error };
            }
          });

        return result;

        break;
      case "delete":
        result = serviceInstance
          .delete(url, config)
          .then((response) => {
            return response.data;
          })
          .catch(function (error) {
            if (error.response) {


              switch (error.response.status) {
                case 422:
                  if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                    sendNotification(`Error 422 en DELETE ${url}: ${JSON.stringify(error.response.data)}`);
                  }
                  return { error: validation(error.response.data) };

                  break;

                case 500:
                  let errMsg = 'Error interno';
                  if (error.response.hasOwnProperty("data")) {
                    if (error.response.hasOwnProperty("message")) {
                      errMsg = error.response.data;
                    } else {
                      errMsg = error.response.data.message;
                    }
                  } else {
                    errMsg = error.response.data.message;
                  }
                  if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                    sendNotification(`Error 500 en DELETE ${url}: ${errMsg}`);
                  }
                  return { error: errMsg };
                  break;
              }
            } else {
              if (window.location.pathname === '/app/cotizaciones' || window.location.pathname === '/app/nueva/cotizacion') {
                sendNotification(`Error de red o desconocido en DELETE ${url}: ${error.message || error}`);
              }
              return { error: error };
            }
          });

        return result;

        break;

      default:
        break;
    }

    return {
      formatrespuesta,
      validation,
      config,
      user,
      _axios_config: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "",
        },
      },
    };
  },
};
